import React, { useEffect, useState } from "react";
import LinksCard from "./LinksCard";

// JS Files

// Others File
import link1 from "../../imgs/link-1.svg";
import link2 from "../../imgs/link-2.svg";
import link3 from "../../imgs/link-3.svg";

const LinksRightSide = () => {
  return (
    <>
      <div className="rounded-lg p-4 md:p-8 bg-myorange-600">
        <p className="font-bold text-lg text-mygray-600">دسترسی سریع</p>
        <div className="md:mx-12 mt-4">
          <LinksCard
            icon={link1}
            header="مراجع درمانی طرف قرارداد بیمه‌گر"
            route="https://www.dana-insurance.com/fa-IR/Portal/5301/page/%D9%85%D8%B1%D8%A7%DA%A9%D8%B2-%D8%AF%D8%B1%D9%85%D8%A7%D9%86%DB%8C-%D8%B7%D8%B1%D9%81-%D9%82%D8%B1%D8%A7%D8%B1%D8%AF%D8%A7%D8%AF"
          />
          <LinksCard
            icon={link2}
            header="شعب بیمه‌گر"
            route="https://www.dana-insurance.com/fa-IR/Portal/4949/page/%D8%B4%D8%B9%D8%A8"
          />
          <LinksCard
            icon={link3}
            header="شعب ایرانیان پوشش"
            route="https://iranianpooshesh.com/branches"
          />
        </div>
      </div>
    </>
  );
};
export default LinksRightSide;
